import React from "react";
import { toPer } from "./Methods";
import "../style/error.css";
export default function Err(props){
    return <section className="flex flexCol container rtl errorContainer">
        <p className="titrFont textSize2 textClr3 errorMsg flex flexCenter">{toPer(props.error.toLocaleString())}</p>
        {props.hasTryAgain ? "" : <button className="faFont textSize4 textClr5 tryAgainBtn fitContent" onClick={()=>props.clickHandler()}>تلاش دوباره</button>}
    </section>
}